import { Modal } from "react-bootstrap";
import { tradicionDe } from "./tradicion";
import "./Tradmodl.css";

/**
 * Modal con los cargues de jerarquia menor que oculta la tarjeta visible.
 * Ing. Carlos F. Castaneda M.
 */
const Tradmodl = ({
  show,
  onClose,
  principal,
  versiones = [],
  viewFiles,
  viewMetada,
  viewLine,
  permisosPorFila = {},
  onEditar,
  onEliminar,
  onInvalidar,
}) => {
  const esImagen = (row) =>
    row.TYPEXXXX === "image/png" || row.TYPEXXXX === "image/jpeg" || row.TYPEXXXX === "image/jpg";

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton className="modal-header">
        <Modal.Title className="td-title">
          <span className="td-title__tipo">{principal?.TIPODESX}</span>
          <span className="td-title__sub">
            Tradiciones documentales de jerarquia menor
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {versiones.length === 0 ? (
          <div className="td-vacio">No hay cargues de jerarquia menor.</div>
        ) : (
          <div className="td-lista">
            {versiones.map((row) => {
              const permisos = permisosPorFila[String(row.IDARCHXX)];
              return (
                <div className="td-item" key={row.IDARCHXX}>
                  <img
                    className="td-item__ico"
                    src={`${process.env.REACT_APP_GESTOR_WEB}/${row.imgfilex}`}
                    alt="documento"
                  />
                  <div className="td-item__info">
                    <div className="td-item__trad">{tradicionDe(row)}</div>
                    <div className="td-item__meta">
                      <strong>ID</strong> : {row.IDARCHXX}
                    </div>
                    <div className="td-item__meta">
                      <strong>FECHA</strong> : {row.REGFECXX} / {row.REGHORXX}
                    </div>
                  </div>
                  <div className="td-item__acc">
                    <img
                      onClick={() => viewLine(row)}
                      src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-timeline.png`}
                      height={26}
                      alt="time line"
                      title="Trazabilidad"
                      style={{ cursor: "pointer" }}
                    />
                    <img
                      onClick={() => viewMetada(row.METADATX, row.JSONMETX, row.METAEXCE)}
                      src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-info.png`}
                      height={26}
                      alt="info"
                      title="Metadatos"
                      style={{ cursor: "pointer" }}
                    />
                    <img
                      onClick={() => viewFiles(row)}
                      src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-view.png`}
                      height={26}
                      alt="view"
                      title={esImagen(row) ? "Ver imagen" : "Ver documento"}
                      style={{ cursor: "pointer" }}
                    />
                    {/*
                      Editar/Eliminar/Invalidar solo aparecen cuando ya se
                      calcularon los permisos de ESTE cargue (permisos es
                      undefined mientras esta pendiente la consulta al
                      abrir el modal) y el usuario cuenta con el permiso.
                    */}
                    {permisos?.update && onEditar && (
                      <i
                        className="bi bi-pencil-square td-item__accion td-item__accion--editar"
                        onClick={() => onEditar(row)}
                        title="Editar"
                        role="button"
                      ></i>
                    )}
                    {permisos?.delete && onEliminar && (
                      <i
                        className="bi bi-trash td-item__accion td-item__accion--eliminar"
                        onClick={() => onEliminar(row)}
                        title="Eliminar"
                        role="button"
                      ></i>
                    )}
                    {permisos?.invalidate && onInvalidar && (
                      <i
                        className="bi bi-slash-circle td-item__accion td-item__accion--invalidar"
                        onClick={() => onInvalidar(row)}
                        title="Invalidar"
                        role="button"
                      ></i>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default Tradmodl;
